import { Navigate } from "react-router-dom";

/*
 * PaymentCancel — Stripe checkout ka cancel_url.
 *
 * Pehle is path ka koi route hi NAHI tha. Stripe user ko /payment-cancel pe
 * chhod deta tha, <Routes> me kuch match nahi hota tha, blank page aa jaata
 * tha — aur wahan se user bhatak kar /business-step pe pahunch jaata (SecureRoute
 * onboarding-incomplete par wahi bhejta hai). Yaani plan cancel karte hi user
 * agent-creation flow me phans jaata tha.
 *
 * Ab wapas wahin bhejte hain jahan se checkout shuru hua tha. Wo path checkout
 * se PEHLE stash hota hai (setPaymentCancelReturn), kyunki Stripe ek poora page
 * load hai — history aur in-memory state dono udd chuke hote hain.
 */

const RETURN_KEY = "paymentCancelReturnTo";

// Checkout pe jaane se THEEK pehle call karo.
export const setPaymentCancelReturn = (path) => {
    try {
        if (path) sessionStorage.setItem(RETURN_KEY, path);
    } catch {
        /* storage blocked — default pe chala jayega */
    }
};

const readReturn = () => {
    try {
        const v = sessionStorage.getItem(RETURN_KEY);
        sessionStorage.removeItem(RETURN_KEY); // ek hi baar
        // Sirf apne hi app ke andar ka path — bahar ka URL kabhi nahi.
        return v && v.startsWith("/") && !v.startsWith("//") ? v : null;
    } catch {
        return null;
    }
};

const PaymentCancel = () => {
    // Stash na mile to agent home — wahi safe jagah hai jahan se user ne
    // aksar checkout shuru kiya hoga.
    const to = readReturn() || "/fast-agent-detail";
    return <Navigate to={to} replace />;
};

export default PaymentCancel;
